import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'

export const ButtonTopRight = ({ routeTo, materialUIText, ...attrs }) => {
    
    return (
        <Link to={routeTo}>
            <Button size="sm" theme="white" className="mb-2 mr-1 btn btn-white btn-sm btn-pill">
                <i className="material-icons md-18">{ materialUIText }</i>
            </Button>
        </Link>
    )
}
